import React from 'react';
import { Capability } from '__types__';
import { useFilterMenuAccess } from 'lib/restrictedAccess';
import { PageTabs } from 'v1/components/shared';

type TabDef = {
  capabilities: Capability;
  text: string;
  container: string;
};

type ProductionSetUpModalTabsProps = {
  tabs: TabDef[];
  activeContainer: string;
  onTabSelect: (container: string) => void;
};

/**
 * Class-safe wrapper: filterMenuAccess needs browsing-scope flags via the hook.
 */
export function ProductionSetUpModalTabs({
  tabs,
  activeContainer,
  onTabSelect
}: ProductionSetUpModalTabsProps) {
  const filteredTabs = useFilterMenuAccess(tabs as never);
  return (
    <PageTabs
      // @ts-expect-error PageTabs is untyped JS (`tabs = []` infers never[])
      tabs={filteredTabs}
      activeContainer={activeContainer}
      onTabSelect={onTabSelect}
    />
  );
}
